module.exports = __webpack_public_path__ + "media/newstyle/images/70-mil-authors-aus-676571a294eb5fb011bf76b196ac11dd.svg";